import { createSlice } from '@reduxjs/toolkit'

// Initial state
const initialState =  {
    programOverviewLoading: true,
    programOverview: null,
    organizationTrainees: null,
    organizationTrainers: null,
    organizationTraineeCompletedWorkoutRecords: null,
    organizationStats: null
}

// Trainer Slice
const userSlice = createSlice({
  name: 'trainer',
  initialState,
  reducers: {
    setTrainerProgramOverviewLoading: (state, action) => { state.programOverviewLoading = action.payload; },
    setTrainerProgramOverview: (state, action) => { state.programOverview = action.payload; },
    updateTrainerProgramWorkoutTemplate: (state, action) => {

        const weekIndex = action.payload.weekIndex;
        const programWorkoutTemplateIndex = action.payload.programWorkoutTemplateIndex;

        state.programOverview.programFileContent.weeks[weekIndex].programWorkoutTemplates[programWorkoutTemplateIndex].workoutTemplateFileContent = action.payload.programWorkoutTemplate;

    },
    setTrainerOrganizationTrainees: (state, action) => { state.organizationTrainees = action.payload },
    setTrainerOrganizationTrainers: (state, action) => { state.organizationTrainers = action.payload },
    setTrainerOrganizationTraineeCompletedWorkoutRecords: (state, action) => { state.organizationTraineeCompletedWorkoutRecords = action.payload },
    setTrainerOrganizationStats: (state, action) => { state.organizationStats = action.payload },
    resetTrainerState: () => initialState
  },
});

export const { 
  setTrainerProgramOverviewLoading,
  setTrainerProgramOverview,
  updateTrainerProgramWorkoutTemplate,
  setTrainerOrganizationTrainees,
  setTrainerOrganizationTrainers,
  setTrainerOrganizationTraineeCompletedWorkoutRecords,
  setTrainerOrganizationStats,
  resetTrainerState 
} = userSlice.actions;

export default userSlice.reducer;